import type { Option } from "./gulaConstants";

/** Compact native select for filter bars. Empty value = no filter. */
export const FilterSelect = ({
  label,
  value,
  onChange,
  options,
  allLabel = "Todos",
  showAll = true,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  allLabel?: string;
  /** False when "all" is one of the options with its own value */
  showAll?: boolean;
}) => (
  <label className="flex items-center gap-1.5 text-sm text-muted-foreground">
    {label}
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className={`h-8 rounded-md border bg-background px-2 text-sm ${
        value ? "border-primary text-foreground" : "text-foreground"
      }`}
    >
      {showAll ? <option value="">{allLabel}</option> : null}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </label>
);
